export interface StickerPools {
  happy: string[];
  angry: string[];
}

export interface NotificationStickerOptions {
  pools: StickerPools;
  happyEvents: Array<string | number>;
  placeholder?: string;
}

const S3_BASE = 'https://elevok-bucket.s3.ap-south-1.amazonaws.com/loyalcraft';
const HAPPY_STICKERS = [
  `${S3_BASE}/emoji-14.svg`,
  `${S3_BASE}/emoji-15.svg`,
  `${S3_BASE}/emoji-16.svg`,
  `${S3_BASE}/emoji-17.svg`,
  `${S3_BASE}/emoji-18.svg`,
  `${S3_BASE}/emoji-19.svg`,
  `${S3_BASE}/emoji-20.svg`,
];

const ANGRY_STICKERS = [
  `${S3_BASE}/emoji-1.svg`,
  `${S3_BASE}/emoji-2.svg`,
  `${S3_BASE}/emoji-3.svg`,
  `${S3_BASE}/emoji-4.svg`,
  `${S3_BASE}/emoji-5.svg`,
  `${S3_BASE}/emoji-6.svg`,
  `${S3_BASE}/emoji-7.svg`,
  `${S3_BASE}/emoji-8.svg`,
  `${S3_BASE}/emoji-9.svg`,
  `${S3_BASE}/emoji-10.svg`,
  `${S3_BASE}/emoji-11.svg`,
  `${S3_BASE}/emoji-12.svg`,
  `${S3_BASE}/emoji-13.svg`,
];

export function createStickerPools(options?: {
  shuffle?: (input: string[]) => string[];
  stickers?: StickerPools;
}): StickerPools {
  const shuffle = options?.shuffle;
  const happy = options?.stickers?.happy ?? HAPPY_STICKERS;
  const angry = options?.stickers?.angry ?? ANGRY_STICKERS;
  return {
    happy: shuffle ? shuffle([...happy]) : [...happy],
    angry: shuffle ? shuffle([...angry]) : [...angry],
  };
}

export function getNotificationSticker(
  notif: { id?: string | number; event?: string | number; action?: { reputationLoss?: number } } | null | undefined,
  options: NotificationStickerOptions,
): string {
  const placeholder = options.placeholder ?? 'assets/img/avatars/placeholder.png';
  if (!notif) return placeholder;

  const useHappy = options.happyEvents.includes(notif.event as string | number);
  const pool = useHappy ? options.pools.happy : options.pools.angry;

  if (!pool || !pool.length) return placeholder;

  let idx = 0;
  if (notif.id !== undefined && notif.id !== null) {
    idx = Math.abs(hashString(String(notif.id))) % pool.length;
  } else if (notif.action?.reputationLoss !== undefined) {
    idx = Math.abs(Math.round(notif.action.reputationLoss)) % pool.length;
  } else {
    idx = Math.floor(Date.now() % pool.length);
  }

  return pool[idx];
}

function hashString(str: string): number {
  let hash = 5381;
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 33) ^ str.charCodeAt(i);
  }
  return hash >>> 0;
}
